import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import { passwordResetApi, passwordResetVerifyApi } from '~/api';
import { useBoolean } from '~/hooks/useBoolean';
import { ApiResponseEnum, apiResponseHandler } from '~/utils/api';

export function useResetPassword() {
  const [isLoading, loadingActions] = useBoolean();
  const [isValid, validActions] = useBoolean();
  const [isSubmitted, submittedActions] = useBoolean();
  const [msg, setMsg] = useState('');
  const [password, setPassword] = useState('');
  const { token } = useParams();

  async function verifyToken() {
    if (!token) {
      toast.error('Invalid Token');
      return;
    }

    loadingActions.on();
    const promise = passwordResetVerifyApi(token);
    const response = await apiResponseHandler<{}>(promise);

    if (response.type === ApiResponseEnum.Success) {
      setMsg(response.msg ?? 'Token verified!');
      validActions.on();
    } else {
      setMsg(response.error.toString() ?? 'An error occurred!');
      validActions.off();
    }
    loadingActions.off();
  }

  async function handleSubmit() {
    if (!token) {
      toast.error('Invalid Token');
      return;
    }
    const trimmedPass = password.trim();

    if (!trimmedPass) {
      toast.error('Enter valid password');
      return;
    }

    loadingActions.on();

    const promise = passwordResetApi(token, { password: trimmedPass });
    const response = await apiResponseHandler<{}>(promise);

    if (response.type === ApiResponseEnum.Success) {
      setMsg('Password reset successful! You can now proceed to log in.');
      submittedActions.on();
    } else {
      setMsg(response.error.toString() ?? 'An error occurred!');
    }

    loadingActions.off();
  }

  useEffect(() => {
    verifyToken();
  }, [token]);

  return { msg, isLoading, isValid, password, setPassword, isSubmitted, handleSubmit };
}
